import Th from "./Th";

const Thead = ({ tableHeadData, checked = false }) => {
  return (
    <>
      <thead>
        <tr className="text-white  text-xs leading-none border-b-2 border-magenta-100">
          {tableHeadData.map((item, i) => (
            <Th
              key={i}
              thClass={item.thClass}
              name={item.name}
              nameAlign={item.align}
              isSort={item.isSort}
              isFilter={item.isFilter}
              filterDropdown={item?.filterData}
              onSort={item?.onSort}
              onFilter={item?.onFilter}
              filterData={item?.filterData}
              filterSearch={item?.filterSearch}
              content={item?.content}
              type={item.type}
              onFilterScroll={item?.onFilterScroll}
              isFilterSearch={item.isFilterSearch}
              checkboxChecked={checked}
              onCheckboxChange={() =>
                item.onCheckboxChange
                  ? item.onCheckboxChange(item.itemDetails || {})
                  : () => {}
              }
            />
          ))}
        </tr>
      </thead>
    </>
  );
};

export default Thead;
